/**
 * <LastReportSection> — "Dernier bilan" on the parent home (template).
 *
 * Renders nothing when there is no report: a family that has not had a session yet is not
 * told it has no report. Thin domain wrapper over `<List>` + `<LastReportCard>`.
 */
import React from "react"

import { List } from "../../molecules/List"
import { LastReportCard } from "../../organisms/LastReportCard"
import { type UIParentLastReport } from "../../../ports/primary/ui/types"

export type LastReportSectionProps = {
    report: UIParentLastReport | null
    /** Opens the report — the whole card is the target. */
    onOpenReport?: () => void
    testID?: string
}

export function LastReportSection(props: LastReportSectionProps) {
    const { report, onOpenReport, testID } = props
    if (report == null) return null

    return (
        <List title="Dernier bilan" testID={testID}>
            <LastReportCard report={report} onPress={onOpenReport} />
        </List>
    )
}
